import { type DataQuery } from '@grafana/schema';

export type QueryLibraryEventsPropertyMap = Record<string, string | number | boolean | undefined>;

export type AddQueryTemplateCommand = {
  title: string;
  description?: string;
  tags: string[];
  isVisible?: boolean;
  targets: DataQuery[];
  isLocked?: boolean;
};

export enum QueryLibraryTab {
  ALL = 'all',
  FAVORITES = 'favorites',
  RECENT = 'history',
  FEEDBACK = 'feedback',
}

export type QueryDetails = {
  title: string;
  description: string;
  isVisible: boolean;
  tags: string[];
};
